import { useGroup } from 'hooks/useGroup'
import { useGroupPrices } from 'hooks/useGroupPrices'
import { useRemoteConstants } from 'hooks/useRemoteConstants'

export const useGroupWithPrices = (trainerId?: string) => {
  const { data: group, isLoading: isGroupLoading } = useGroup({
    userId: trainerId,
  })
  const { data: groupStripePrices, isLoading: isGroupPricesLoading } = useGroupPrices({
    groupId: group?.id,
  })
  const { data: constants } = useRemoteConstants()
  const clientFeeMinimumCents = constants?.CLIENT_FEE_MINIMUM_CENTS || 0
  const clientFeePercent = constants?.CLIENT_PLATFORM_FEE_PERCENT || 0
  const trainerFeePercent = constants?.TRAINER_PLATFORM_FEE_PERCENT || 0

  const mergedPrices = group?.prices?.map((price) => {
    const foundPrice = groupStripePrices?.find((stripePrice) => stripePrice.id === price.id)

    const basePriceCents = foundPrice?.unit_amount || 0
    const fee = Math.max(basePriceCents * (clientFeePercent / 100), clientFeeMinimumCents)
    const payout = basePriceCents * ((100 - trainerFeePercent) / 100)
    const charge = basePriceCents + fee

    return {
      ...price,
      base: basePriceCents,
      charge,
      payout,
      fee,
    }
  })
  return {
    isLoading: isGroupLoading || isGroupPricesLoading,
    data: {
      ...group,
      prices: mergedPrices,
    },
  }
}
